/* Native Shopify contact forms remain functional without this enhancement. */
(() => {
  const validLocalProductUrl = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      const hosts = [window.location.hostname, document.documentElement.dataset.shopHost].filter(Boolean);
      return /^https?:$/.test(url.protocol) && hosts.includes(url.hostname) && /^\/products\/[a-z0-9-]+\/?$/.test(url.pathname)
        ? `${url.origin}${url.pathname}` : '';
    } catch { return ''; }
  };
  const init = (root = document) => {
    root.querySelectorAll('[data-ms-gallery]:not([data-ready])').forEach(gallery => {
      gallery.dataset.ready = 'true';
      const media = [...gallery.querySelectorAll('[data-ms-media]')];
      const links = [...gallery.querySelectorAll('[data-ms-thumb]')];
      if (!media.length) return;
      const activate = (id) => {
        media.forEach(item => {
          item.hidden = item.id !== id;
          if (item.hidden) item.querySelectorAll('video').forEach(video => video.pause());
        });
        links.forEach(link => link.setAttribute('aria-current', String(link.hash === `#${id}`)));
      };
      gallery.classList.add('is-enhanced');
      activate(media[0].id);
      links.forEach(link => link.addEventListener('click', event => {
        event.preventDefault(); activate(link.hash.slice(1));
      }));
    });
    root.querySelectorAll('[data-ms-quote-form]:not([data-ready])').forEach(form => {
      form.dataset.ready = 'true';
      if (form.dataset.general === 'true') {
        const query = new URLSearchParams(window.location.search);
        const product = query.get('product');
        const model = query.get('model');
        const url = validLocalProductUrl(query.get('product_url'));
        if (product) form.querySelector('[name="contact[Product]"]').value = product.slice(0, 180);
        if (model) form.querySelector('[name="contact[Model]"]').value = model.slice(0, 100);
        if (url) form.querySelector('[name="contact[Product URL]"]').value = url;
      }
      const status = form.querySelector('[data-ms-form-status]');
      if (status) status.focus();
      if (!form.querySelectorAll || !form.addEventListener) return;
      const fields = [...form.querySelectorAll('input:not([type="hidden"]), textarea, select')];
      const draftKey = `milestone-enquiry:${window.location.pathname}:${form.dataset.general}`;
      const now = () => Date.now();
      const draftLifetime = 30 * 60 * 1000;
      const removeDraft = () => { try { window.sessionStorage.removeItem(draftKey); } catch {} };
      if (form.querySelector('[data-ms-success]')) removeDraft();
      else {
        try {
          const draft = JSON.parse(window.sessionStorage.getItem(draftKey) || 'null');
          if (draft && now() - draft.savedAt < draftLifetime) {
            fields.forEach(field => {
              const value = draft.values[field.name];
              if (!field.value && typeof value === 'string') field.value = value.slice(0, field.maxLength > 0 ? field.maxLength : 5000);
            });
          } else if (draft) removeDraft();
        } catch { removeDraft(); }
      }
      const saveDraft = () => {
        try { window.sessionStorage.setItem(draftKey, JSON.stringify({ savedAt: now(), values: Object.fromEntries(fields.map(field => [field.name, field.value])) })); } catch {}
      };
      form.addEventListener('input', saveDraft);
      const extra = form.querySelector('.ms-form-extra');
      if (extra && [...extra.querySelectorAll('input')].some(field => field.value)) extra.open = true;
      const submit = form.querySelector('[data-ms-submit]');
      const label = form.querySelector('[data-ms-submit-label]');
      const initialLabel = label?.textContent;
      const resetSubmission = () => {
        form.removeAttribute('aria-busy');
        if (submit) submit.disabled = false;
        if (label) label.textContent = initialLabel;
      };
      form.addEventListener('submit', event => {
        saveDraft();
        // Shopify's anti-spam handler may prevent a submit to open its challenge.
        // Check after other submit listeners; never intercept its resubmission.
        window.setTimeout(() => {
          if (event.defaultPrevented || !form.checkValidity()) return;
          form.setAttribute('aria-busy', 'true');
          if (submit) submit.disabled = true;
          if (label) label.textContent = submit.dataset.loadingLabel;
          window.setTimeout(resetSubmission, 12000);
        }, 0);
      });
      window.addEventListener('pageshow', resetSubmission);
    });
    root.querySelectorAll('[data-ms-variant]:not([data-ready])').forEach(select => {
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const model = option.dataset.model;
        const productSection = select.closest('[data-ms-product]');
        productSection.querySelectorAll('[data-ms-model]').forEach(element => { element.textContent = model; });
        productSection.querySelectorAll('[name="contact[Model]"]').forEach(input => { input.value = model; });
        productSection.querySelectorAll('[name="contact[Variant]"]').forEach(input => { input.value = option.textContent.trim(); });
      });
    });
    root.querySelectorAll('.ms-menu:not([data-ready])').forEach(menu => {
      menu.dataset.ready = 'true';
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  const floating = document.querySelector?.('.ms-floating');
  if (floating && 'IntersectionObserver' in window) {
    const visible = new Set();
    const observer = new window.IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
      floating.classList.toggle('is-context-hidden', visible.size > 0);
    });
    document.querySelectorAll('.ms-footer, #quote, #product-quote, [data-ms-toc], .ms-story-body, .ms-story-products, .ms-journal-card-copy').forEach(target => observer.observe(target));
  }
})();
